export const MESSAGES_LOAD_SUCCESS = 'MESSAGES_LOAD_SUCCESS';
export const MESSAGES_LOAD_ERROR = 'MESSAGES_LOAD_ERROR';
